<nb-card class="dialog-card pre-inscricao-grupos">
  <nb-card-header>
    <span class="titulo">Grupos e vagas</span>
    <span class="subtitulo" *ngIf="campanhaNome">{{ campanhaNome }}</span>
  </nb-card-header>

  <nb-card-body>
    <div class="carregando" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando grupos…</span>
    </div>

    <table class="grupos-table" *ngIf="!carregando && grupos.length">
      <thead>
        <tr>
          <th>Grupo</th>
          <th class="col-num">Faixa etária</th>
          <th class="col-num">Ocupação</th>
          <th class="col-acoes">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let g of grupos">
          <td>{{ g.nome }}</td>
          <td class="col-num">{{ g.idadeMinima }} a {{ g.idadeMaxima }} anos</td>
          <td class="col-num">{{ g.vagasOcupadas || 0 }} / {{ g.limiteVagas || 0 }}</td>
          <td class="col-acoes">
            <div class="acao-btns acao-btns--inline" role="group">
              <button
                type="button"
                nbButton
                size="small"
                appearance="outline"
                status="basic"
                class="btn-acao"
                (click)="editar(g)"
                title="Editar grupo"
                aria-label="Editar grupo"
              >
                <nb-icon pack="eva" icon="edit-outline"></nb-icon>
              </button>
              <button
                type="button"
                nbButton
                size="small"
                appearance="outline"
                status="danger"
                class="btn-acao"
                [disabled]="!!g.vagasOcupadas"
                (click)="excluir(g)"
                [title]="g.vagasOcupadas ? 'Grupo com inscrito não pode ser excluído' : 'Excluir grupo'"
                aria-label="Excluir grupo"
              >
                <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="vazio" *ngIf="!carregando && !grupos.length">
      Nenhum grupo ainda. Sem grupo, o link público não tem onde encaixar quem se inscreve.
    </p>

    <form class="form-grupo" (ngSubmit)="salvar()">
      <span class="form-titulo">{{ editandoId ? 'Editar grupo' : 'Novo grupo' }}</span>

      <div class="linha">
        <div class="campo campo--nome">
          <label class="field-label" for="g-nome">Nome</label>
          <input nbInput fullWidth id="g-nome" name="nome" placeholder="Ex.: Catequese 1" [(ngModel)]="nome" />
        </div>
        <div class="campo">
          <label class="field-label" for="g-min">Idade mínima</label>
          <input nbInput fullWidth id="g-min" name="idadeMinima" type="number" min="0" [(ngModel)]="idadeMinima" />
        </div>
        <div class="campo">
          <label class="field-label" for="g-max">Idade máxima</label>
          <input nbInput fullWidth id="g-max" name="idadeMaxima" type="number" min="0" [(ngModel)]="idadeMaxima" />
        </div>
        <div class="campo">
          <label class="field-label" for="g-vagas">Limite de vagas</label>
          <input nbInput fullWidth id="g-vagas" name="limiteVagas" type="number" min="1" [(ngModel)]="limiteVagas" />
        </div>
      </div>

      <div class="form-acoes">
        <button nbButton size="small" status="basic" type="button" *ngIf="editandoId" (click)="cancelarEdicao()">
          Cancelar edição
        </button>
        <button nbButton size="small" status="primary" type="submit" [disabled]="salvando" [nbSpinner]="salvando">
          {{ editandoId ? 'Salvar grupo' : 'Adicionar grupo' }}
        </button>
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer class="footer-actions">
    <button nbButton status="primary" size="medium" type="button" (click)="fechar()">Fechar</button>
  </nb-card-footer>
</nb-card>
